<bottomsheet-layout (dismiss)="closeBottomSheet()">
  <div class="tw-px-2">
    <div class="tw-flex tw-justify-center">
      <div class="tw-w-fit tw-relative">
        <img [src]="productImage" class="tw-w-30 tw-h-[150px] tw-object-contain tw-rounded-3" alt="product" />
        <div class="tw-absolute tw-top-[10px] tw-right-0 tw-translate-x-1/2 tw-translate-y-0">
          <img class="tw-w-[37px] tw-h-[37px]" src="/assets/images/exclamation_orange_inverted.png" alt="exclamation" />
        </div>
      </div>
    </div>

    @if (isNewMom) {
      <p class="tw-text-center tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-mt-4 tw-mb-2.5" i18n="@@notSafeForNewMoms">Not Safe For New Moms</p>
    } @else {
      <p class="tw-text-center tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-mt-4 tw-mb-2.5" i18n="@@notPregnancySafe">Not Pregnancy Safe</p>
    }

    <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500 tw-text-center">
      @if (isNewMom) {
        <span i18n="@@productContainsIngredientsMayNotBeSafeForBreastfeeding">{{data.product.title}} contains ingredients that may not be safe for breastfeeding, so we don't recommend it for you </span>
      } @else if (isPlanningForPregnancy) {
        <span i18n="@@productContainsIngredientsMayNotBeSafeIfPregnant">{{data.product.title}} contains ingredients that may not be safe during pregnancy.</span>
        <span class="tw-block tw-font-bold tw-text-gray-500" i18n="@@ifYouBecomePregnantWeRecommendStopUsingIt">If you become pregnant, we recommend stop using it</span>
      } @else {
        <span i18n="@@productContainsIngredientsThatMayNotBeSafeDuringPregnancy">{{data.product.title}} contains ingredients that may not be safe during pregnancy, so we don't recommend it for you </span>
      }
    </p>
  </div>

  <div class="tw-mt-8">
    @if (data.navigateToArticlePage) {
      <button csButton
            (click)='closeBottomSheet()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@OkClose">Ok, Close</span>
      </button>
      <button csButton="muted"
              (click)='navigateToArticle()'
              class="tw-w-full tw-text-500 tw-font-semibold tw-capitalize tw-max-w-full"
              style="margin: 0 !important;">
        <span i18n="@@viewProduct">view product</span>
      </button>
    } @else if (isPlanningForPregnancy) {
      <button csButton
            (click)='addToCart()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@okAddToCart">Ok, Add to cart</span>
      </button>
    } @else {
      <button csButton
            (click)='closeBottomSheet()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@okDontAdd">Ok, Don't Add</span>
      </button>
      <button csButton="muted"
            (click)='addToCart()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@addToCartAnyWay">Add to Cart Anyway </span>
      </button>
    }
  </div>
</bottomsheet-layout>
